import { pushProductAddToWishlist, pushProductRemoveFromWishlist } from "./utils";

const initDataLayerEvents = () => {
    /**
     * Attaches the global event to product being added to wishlist and does a dataLayer push of this event when it happens.
    */
    document.addEventListener("dataLayer.addToWishlist", data => {
        const eventData = data?.detail;
        const addProductImpression = Object.assign({}, eventData.productImpression, {
            "customerId" : eventData.customerId
        });

        pushProductAddToWishlist([addProductImpression]);
    });

    /**
     * Attaches the global event to product being removed from the wishlist and does a dataLayer push of this event when it happens.
    */
    document.addEventListener("dataLayer.removeFromWishlist", data => {
        const eventData = data?.detail;
        const removeProductImpression = Object.assign({}, eventData.productImpression, {
            "customerId" : eventData.customerId
        });

        pushProductRemoveFromWishlist([removeProductImpression]);
    });
};


module.exports = {
    initDataLayerEvents: initDataLayerEvents
};
